<template>
  <div>
    <div class="account-header">
      <div class="header-box">
        <div class="header-logo">
          <a
            :href="siteConfig.logoLink == '' ? '/' : siteConfig.logoLink"
            v-show="siteConfig.logo"
          >
            <img :src="concatImageUrl(siteConfig.logo)" />
          </a>
        </div>
      </div>
    </div>
    <div class="account-body">
      <div class="account-box">
        <div class="account-img">
          <div
            class="img"
            v-if="siteConfig.registerImage"
            :style="
              'background: url(' +
              concatImageUrl(siteConfig.registerImage) +
              ') no-repeat center;'
            "
          ></div>
          <div
            class="img"
            v-else
            :style="
              'background: url(' +
              require('../../assets/images/v3/account-default-cover.png') +
              ') no-repeat center'
            "
          ></div>
        </div>
        <div class="account-wrapper">
          <div class="account-tab">
            <span v-if="siteConfig.agencyId === 3963" class="selected">
              在线试看
            </span>
            <span v-else class="selected">用户注册</span>
          </div>
          <div v-if="errorTip" class="account-error">
            <Icon type="md-alert" size="18" />
            <span>{{ errorTip }}</span>
          </div>
          <form class="account-form" @submit.prevent="submit($event)">
            <div class="form-item">
              <i-input
                v-model="model.mobile"
                type="text"
                placeholder="请输入您的手机号"
                size="large"
              >
                <Icon custom="ich-icon ich-icon-phone" slot="prefix" />
              </i-input>
            </div>
            <div class="form-item">
              <i-input
                v-model="imageCode"
                maxlength="4"
                placeholder="请输入验证码"
                size="large"
              >
                <Icon custom="ich-icon ich-icon-diamond" slot="prefix" />
                <span class="verify-code" @click="getCodeUrl()" slot="suffix">
                  <img
                    id="verifyCode"
                    title="点击刷新"
                    alt="验证码"
                    :src="verifyCodeUrl"
                    style="cursor: pointer"
                  />
                </span>
              </i-input>
            </div>
            <div class="form-item">
              <i-input
                v-model="model.verifycode"
                maxlength="6"
                placeholder="请输入验证码"
                size="large"
              >
                <Icon custom="ich-icon ich-icon-diamond" slot="prefix" />
                <a class="phone-code" @click="getPhoneCode()" slot="suffix">
                  {{ phoneCodeText }}
                </a>
              </i-input>
            </div>
            <!-- sultan-form -->
            <div class="form-item">
              <i-input
                name="test"
                maxlength="18"
                placeholder="请输入用户名"
                size="large"
                v-model="model.username"
              >
                <!-- @keyup.enter="checkUserName" @input="checkUserName($event)" -->
                <Icon custom="ich-icon ich-icon-user" slot="prefix" />
              </i-input>
            </div>
            <div class="testTips">
              用户名可以输入中文、大小写英文、下划线、数字，不超过18位，不允许纯数字
            </div>
            <div class="form-item">
              <i-input
                name="test"
                maxlength="18"
                placeholder="请输入密码"
                size="large"
                v-model="model.password"
              >
                <Icon custom="ich-icon ich-icon-user" slot="prefix" />
              </i-input>
              <div class="testTips">
                密码长度8-20位,需包含大小写字母,数字及特殊字符中的至少三种
              </div>
            </div>
            <!-- <div class="form-item">
              <i-input
                name="test"
                maxlength="18"
                placeholder="请输入再次输入密码"
                size="large"
                v-model="model.password"
              >
                <Icon custom="ich-icon ich-icon-user" slot="prefix" />
              </i-input>
            </div> -->

            <div class="form-item" v-show="siteConfig.hiddenPolicy">
              <label>
                <Checkbox v-model="agreeProtocol" style="font-size: 13px"
                  >我已充分阅读服务协议</Checkbox
                >
              </label>
              <span class="protocol-title" @click="protocolVisible = true">
                《隐私协议》
              </span>
              <span class="protocol-title" @click="agreementVisible = true">
                《用户协议》
              </span>
            </div>
            <div class="form-item">
              <button
                v-if="siteConfig.agencyId === 3963"
                type="submit"
                class="submit-btn"
              >
                立即试看
              </button>
              <button v-else type="submit" class="submit-btn">立即注册</button>
              <router-link :to="{ name: 'Login' }" class="form-reg color3">
                已有账号？请登录
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="account-footer">
      <div class="footer-box">
        <div class="footer-info">
          <div class="info-content">
            <template v-if="siteConfig.footerTel && isContact"
              >咨询热线：{{ siteConfig.footerTel }}</template
            >
            <br />工业和信息化部备案号：
            <a href="https://beian.miit.gov.cn" target="_blank">{{
              siteConfig.icpNumber
            }}</a>
          </div>
          <div class="info-content">
            <template v-if="siteConfig.footerQQ && isContact">
              QQ：{{ siteConfig.footerQQ }}</template
            >
            <br />
            <template v-if="siteConfig.title"> {{ siteConfig.title }}</template>
          </div>
        </div>
        <div class="footer-qrcode" v-show="siteConfig.isShowAppQrcode">
          <div class="qrcode-title">APP客户端</div>
          <div class="qrcode-img">
            <!-- <template v-if="!isCustomApp">
              <img src="../../assets/images/app-qrcode.png" alt="qrcode" />
            </template> -->
            <template>
              <vue-qr
                :margin="5"
                :size="90"
                :correctLevel="3"
                :text="appQrcodeData.url"
                :logoSrc="appQrcodeData.icon"
                :logoMargin="5"
                style="display: block"
              ></vue-qr>
            </template>
          </div>
        </div>
      </div>
    </div>
    <Drawer
      title="隐私协议"
      width="640"
      :closable="false"
      v-model="protocolVisible"
    >
      <div v-html="siteConfig.hiddenPolicy"></div>
    </Drawer>
    <Drawer
      title="用户协议"
      width="640"
      :closable="false"
      v-model="agreementVisible"
    >
      <div v-html="siteConfig.userAgreement"></div>
    </Drawer>
    <Modal
      v-model="isRegisterSuccess"
      :closable="false"
      :mask-closable="false"
      width="360"
      class-name="vertical-center-modal"
    >
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-checkmark-circle" />
        <span style="margin-left: 0.5rem">友情提示</span>
      </p>
      <p>&nbsp;</p>
      <div style="text-align: center; line-height: 1.8">
        <p>恭喜您，注册成功！</p>
        <!-- <p>默认登录密码为：Aa123456</p> -->
        <p>登录密码为：{{ model.password }}</p>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="success" size="large" @click="locationMember"
          >进入学习中心</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { account } from "../../request";
import {
  randomNum,
  checkWeakPassword,
  validatePassword2,
} from "../../utils/utils";

import VueQr from "vue-qr";

export default {
  mixins: [siteMixin],
  data() {
    return {
      errorTip: "",
      phoneCodeText: "获取验证码",
      model: {
        username: "",
        password: "",
        entpassword: "",
        mobile: "",
        verifycode: "",
      },
      machine: this.$base64.encode(randomNum(1000, 9999)),
      verifyCode: 0,
      verifyCodeUrl: "",
      imageCode: "",
      isRegisterSuccess: false,
      appQrcodeData: {
        url: "",
        icon: "",
      },
      isCustomApp: false,
      agreeProtocol: true,
      protocolVisible: false,
      agreementVisible: false,
      isContact: true,
    };
  },
  watch: {},
  mounted() {
    // 当前agencyId为0  并且域名不是本公司其下域名，则隐藏
    const hostname = window.location.hostname;
    if (
      this.siteConfig.agencyId === 0 &&
      hostname !== process.env.VUE_APP_WEB_DOMAIN
    ) {
      this.isContact = false;
    }
    this.setMetaData("用户注册");
    this.getCodeUrl();
    this.setQrCode();
    this.randomWord(10);
  },
  methods: {
    getCodeUrl() {
      var baseUrl = process.env.VUE_APP_VERIFY_CODE_URL;
      this.verifyCode = randomNum(100000, 999999);
      // this.verifyCodeUrl = 'http://192.168.1.100:8092/BeegoEduApi/rest/getCode?randdomCode=' + this.verifyCode;
      this.verifyCodeUrl = baseUrl + this.verifyCode;
    },
    getPhoneCode() {
      if (!this.isRequest) {
        if (!this.model.mobile) {
          this.errorTip = "请输入您的手机号";
          return;
        }
        if (!this.imageCode) {
          this.errorTip = "请输入图形验证码";
          return;
        }
        this.isRequest = true;
        account
          .getPhoneCode(
            this.model.mobile,
            0,
            1,
            this.siteConfig.agencyId,
            this.verifyCode,
            this.imageCode
          )
          .then((result) => {
            if (result.status == 1) {
              let second = 60;
              let timer = setInterval(() => {
                second--;
                this.phoneCodeText = `还剩 ${second} 秒`;
                //console.log(second);
                if (second === 0) {
                  this.isRequest = false;
                  this.phoneCodeText = "重新获取";
                  clearInterval(timer);
                }
              }, 1000);
              this.errorTip = "";
            } else {
              this.isRequest = false;
              this.errorTip = result.message;
              this.getCodeUrl();
            }
          })
          .catch(() => {
            this.isRequest = false;
          });
      }
    },
    // 用户名检测 sultan
    checkUserName() {
      const username = this.model.username.trim();

      // 1. 非空检查
      if (!username) {
        this.errorTip = "用户名不能为空";
        return false;
      }

      // 2. 长度检查
      if (username.length < 1 || username.length > 18) {
        this.errorTip = "用户名长度应为1-18个字符";
        return false;
      }

      // 3. 字符格式检查 - 优化原for循环
      const charReg = /^[\u4E00-\u9FA5a-zA-Z0-9_]+$/;
      if (!charReg.test(username)) {
        this.errorTip = "用户名只能包含中文、字母、数字和下划线";
        return false;
      }

      // 4. 纯数字检查 - 优化原isDigit方法
      if (/^\d+$/.test(username)) {
        this.errorTip = "用户名不能全为数字";
        return false;
      }

      // 5. 可选：检查是否包含手机号（如果需要）
      if (/\d{11}/.test(username)) {
        this.errorTip = "用户名不能包含手机号";
        return false;
      }

      // 清除错误信息，返回验证通过
      this.errorTip = "";
      return true;
    },
    // 随机生成10位数字以及字符串（小写）
    randomWord(len) {
      var str = "",
        range = len,
        arr = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z",
        ];
      // 随机产生
      for (var i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }
      this.model.username = "BGID" + str;
    },
    submit: async function (e) {
      if (!this.model.mobile) {
        this.errorTip = "请输入您的手机号";
        return;
      }
      if (!this.model.verifycode) {
        this.errorTip = "请输入验证码";
        return;
      }
      if (!this.model.password) {
        this.errorTip = "请输入您的密码";
        return;
      }
      if (this.model.password) {
        const pswInfo = validatePassword2(this.model.password);
        if (!pswInfo.isValid) {
          // 密码格式错误时添加错误提示
          this.errorTip = pswInfo.message;
          return;
        }
      }
      // 用户名检测
      const isUserName = this.checkUserName();
      if (!isUserName) {
        return;
      }
      if (this.siteConfig.hiddenPolicy && !this.agreeProtocol) {
        this.errorTip = "请仔细阅读服务协议并勾选";
        return;
      }
      const flag = await checkWeakPassword(this.model.password);
      if (!flag) {
        this.$Message.warning({
          title: "提示",
          content: "该密码过于简单，请重新设置。",
        });
        return;
      }
      let data = {
        agencyid: this.siteConfig.agencyId,
        mobile: this.model.mobile,
        verifycode: this.model.verifycode,
        sex: "男",
        nickname: this.model.username,
        username: this.model.username,
        password: this.$md5(this.model.password),
        RegFromTypeId: 8,
        ProductID: 0,
        userId: 0,
        adminId: 0,
      };
      account.userRegister(data).then((res) => {
        //console.log(res);
        if (res.status == 1) {
          this.login(res.data);
          this.isRegisterSuccess = true;
        } else {
          this.errorTip = res.message;
        }
      });
    },
    locationMember() {
      this.$router.push({ name: "MemberCenter" });
    },
    setQrCode() {
      this.appQrcodeData = {
        url: window.location.protocol + "//" + document.domain + "/app",
        icon: this.concatImageUrl(this.siteConfig.qrCodeLogo),
      };
    },
  },
  components: {
    VueQr,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
// sultan
.testTips {
  margin: 4px 0;
  font-size: 12px;
  color: #aaa;
}
.account-header {
  // position: absolute;
  // left: 0;
  // top: 0;
  width: 100%;
  // height: 100px;
  background: #fff;
  z-index: 200;
  .header-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .header-logo {
      width: 250px;
      height: 50px;
      margin: 15px 0;
      overflow: hidden;
      img {
        max-height: 50px;
        max-width: 250px;
      }
    }
  }
}
.account-body {
  // position: absolute;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // right: 0;
  width: 100%;
  height: 720px;
  background: url(../../assets/images/v3/account-bg.png) #001351 center;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  .account-box {
    width: 1060px;
    height: 550px;
    display: flex;
    border-radius: 10px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
    overflow: hidden;
    .account-img {
      width: 670px;
      height: 100%;
      background: rgba(255, 255, 255, 0.1);
      .img {
        width: 100%;
        height: 100%;
        background-size: 100% !important;
      }
    }
    .account-wrapper {
      width: 390px;
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 10px 30px;
      .account-tab {
        width: 100%;
        height: 20px;
        span {
          .inline-block();
          width: 100%;
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          color: #86888b;
          &.selected {
            color: #2596fd;
          }
        }
      }
      .account-error {
        display: flex;
        width: 100%;
        min-height: 30px;
        // line-height: 30px;
        color: #ff4500;
        span {
          .inline-block();
          vertical-align: 0.12em;
          margin-left: 2px;
        }
      }
      .account-form {
        width: 100%;
        .form-item {
          & + .form-item {
            padding-top: 16px;
          }
          i {
            color: #d1d2d4;
            line-height: 38px;
          }
          .ivu-input-suffix {
            .ivu-icon {
              font-size: 24px;
              line-height: 40px;
            }
          }
          .ivu-input {
            border-radius: 8px;
          }
          .verify-code {
            width: 100px;
            height: 100%;
            float: right;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .phone-code {
            width: 100px;
            height: 38px;
            line-height: 38px;
            float: right;
            margin: 1px 1px 0 0;
            background: #f7f7f7;
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
            color: #999;
          }
          .submit-btn {
            width: 100%;
            height: 40px;
            border: none;
            .background-primary();
            text-align: center;
            border-radius: 8px;
            outline: none;
            cursor: pointer;
          }
          .form-reg {
            width: 100%;
            display: inline-block;
            text-align: center;
            margin-top: 12px;
          }
          .protocol-title {
            cursor: pointer;
            color: #27a3ff;
            font-size: 13px;
            &:hover {
              color: #2380fb;
            }
          }
        }
      }
    }
  }
}
.account-footer {
  // position: absolute;
  // left: 0;
  // bottom: 0;
  width: 100%;
  padding: 20px 0;
  background: #fff;
  z-index: 200;
  .footer-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    // justify-content: center;
    .footer-info {
      display: flex;
      height: 120px;
      padding: 10px;
      .info-content {
        line-height: 50px;
        margin-right: 60px;
      }
    }
    .footer-qrcode {
      width: 100px;
      margin-left: 60px;
      .qrcode-title {
        text-align: center;
        // font-weight: bold;
        font-size: 16px;
        color: #666;
        height: 30px;
        line-height: 30px;
      }
      .qrcode-img {
        width: 90px;
        margin: 0 auto;
        img {
          width: 90px;
          height: 90px;
        }
      }
    }
  }
}
</style>
